// extracted by mini-css-extract-plugin
export default {"mainContainer":"ProductHeader_mainContainer__0a72N","container":"ProductHeader_container__FBvfI","buttons":"ProductHeader_buttons__jiSeD"};